import React from "react"
import { StringsProvider } from "@Common/components/StringsProvider"
import localeBundle from "./locale/localeBundle"

export const CalibrationsStringsProvider: React.FC = ({ children }) => (
  <StringsProvider loaders={localeBundle}>{children}</StringsProvider>
)
